import React from 'react';
import { Link } from 'react-router-dom';

const CampusConnect = () => {

  const campusStats = [
    { number: '5,000+', label: 'Students Trained' },
    { number: '20+', label: 'Campuses Engaged' },
    { number: '50+', label: 'Finance Cohorts Delivered' }
  ];

  const campusSupport = [
    {
      icon: '📝',
      title: 'Student Profile Building',
      description: 'We help students translate academic knowledge into strong, finance-ready professional profiles.',
      features: [
        'Finance-focused resumes',
        'Project-based skill articulation',
        'LinkedIn profile optimisation',
        'Career storytelling'
      ]
    },
    {
      icon: '💼',
      title: 'Interview Readiness',
      description: 'Students are trained to approach finance interviews with clarity, structure, and confidence.',
      features: [
        'Technical interview preparation',
        'Finance case discussions',
        'Behavioural interview readiness',
        'Mock interview simulations'
      ]
    },
    {
      icon: '📊',
      title: 'Live Projects & Industry Exposure',
      description: 'Hands-on finance projects that simulate real-world decision-making and analytical thinking.',
      features: [
        'Live finance projects',
        'Case study execution',
        'Industry-style deliverables',
        'Mentor-led reviews'
      ]
    }
  ];

  const campusLogos = [
    { name: 'IIM Ranchi', logo: '/campus-logos/iim-ranchi.png' },
    { name: 'IIM Nagpur', logo: '/campus-logos/iim-nagpur.png' },
    { name: 'IIM Tiruchirappalli', logo: '/campus-logos/iim-trichy.png' },
    { name: 'IIM Visakhapatnam', logo: '/campus-logos/iim-vizag.png' },
    { name: 'SIBM Pune', logo: '/campus-logos/sibm.png' },
    { name: 'KJ Somaiya Institute of Management', logo: '/campus-logos/kj-somaiya.png' },
    { name: 'Delhi School of Economics (DSE)', logo: '/campus-logos/dse.png' },
    { name: 'Department of Financial Studies (DFS)', logo: '/campus-logos/dfs.png' },
    { name: 'ICFAI Business School (IBS)', logo: '/campus-logos/ibs.png' },
    { name: 'Lal Bahadur Shastri Institute of Management (LBSIM)', logo: '/campus-logos/lbsim.png' }
  ];

  const timelineSteps = [
    {
      step: '01',
      title: 'Campus Alignment',
      desc: 'We work closely with faculty and TPOs to understand student profiles, academic structure, and institutional goals.'
    },
    {
      step: '02',
      title: 'Program Customisation',
      desc: 'Training formats, projects, and depth are customised to suit student readiness and semester timelines.'
    },
    {
      step: '03',
      title: 'Training & Execution',
      desc: 'Live sessions, projects, and mentoring delivered by experienced finance professionals.'
    },
    {
      step: '04',
      title: 'Student Readiness',
      desc: 'Students emerge with stronger profiles, confidence, and real-world finance exposure.'
    }
  ];

  return (
    <div className="placement-page">

      {/* ── HERO ── */}
      <section className="cc-hero">
        <div className="cc-hero-inner">
          <div className="cc-hero-content">
            <span className="cc-badge">Campus Partner Programme</span>
            <h1 className="cc-hero-title">
              Intlrr <span className="cc-accent">Campus Connect</span>
            </h1>
            <p className="cc-hero-sub">
              A structured collaboration with academic institutions to strengthen student
              readiness for finance careers through practical exposure, profile building,
              and interview preparation.
            </p>
            <Link to="/contact" className="cc-hero-cta">
              Invite Intlrr to Campus
            </Link>
          </div>
          <div className="cc-hero-visual">
            <div className="cc-visual-blob" />
            <div className="cc-visual-card cc-vc1">
              <span className="cc-vc-num">5,000+</span>
              <span className="cc-vc-lbl">Students Trained</span>
            </div>
            <div className="cc-visual-card cc-vc2">
              <span className="cc-vc-num">20+</span>
              <span className="cc-vc-lbl">Campuses</span>
            </div>
            <div className="cc-visual-card cc-vc3">
              <span className="cc-vc-num">50+</span>
              <span className="cc-vc-lbl">Cohorts Delivered</span>
            </div>
          </div>
        </div>
      </section>

      {/* ── STATS STRIP ── */}
      <section className="cc-stats-strip">
        <div className="cc-stats-inner">
          {campusStats.map((s, i) => (
            <div key={i} className="cc-stat-cell">
              <span className="cc-stat-num">{s.number}</span>
              <span className="cc-stat-lbl">{s.label}</span>
              {i < campusStats.length - 1 && <div className="cc-stat-divider" />}
            </div>
          ))}
        </div>
      </section>

      {/* ── WHAT WE DELIVER ── */}
      <section className="cc-deliver">
        <div className="cc-section-inner">
          <div className="cc-section-header">
            <span className="cc-eyebrow">Our Offering</span>
            <h2 className="cc-section-title">What We Deliver to Campuses</h2>
            <p className="cc-section-sub">
              End-to-end support designed to make your students genuinely finance-ready.
            </p>
          </div>

          <div className="cc-cards-grid">
            {campusSupport.map((item, i) => (
              <div key={i} className="cc-card">
                <div className="cc-card-icon">{item.icon}</div>
                <h3 className="cc-card-title">{item.title}</h3>
                <p className="cc-card-desc">{item.description}</p>
                <ul className="cc-card-features">
                  {item.features.map((f, j) => (
                    <li key={j}>
                      <span className="cc-check">✓</span>{f}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── CAMPUS LOGOS MARQUEE ── */}
      <section className="cc-logos-section">
        <div className="cc-section-inner">
          <div className="cc-section-header">
            <span className="cc-eyebrow">Our Network</span>
            <h2 className="cc-section-title">Campuses We've Engaged With</h2>
          </div>
        </div>

        <div className="cc-marquee-wrap">
          <div className="cc-marquee-fade cc-fade-left" />
          <div className="cc-marquee">
            <div className="cc-marquee-track">
              {[...campusLogos, ...campusLogos].map((c, i) => (
                <div className="cc-logo-item" key={i}>
                  <img src={c.logo} alt={c.name} />
                </div>
              ))}
            </div>
          </div>
          <div className="cc-marquee-fade cc-fade-right" />
        </div>
      </section>

      {/* ── HOW IT WORKS ── */}
      <section className="cc-how">
        <div className="cc-section-inner">
          <div className="cc-section-header">
            <span className="cc-eyebrow">The Process</span>
            <h2 className="cc-section-title">How Campus Connect Works</h2>
          </div>

          <div className="cc-timeline">
            {timelineSteps.map((item, i) => (
              <div key={i} className="cc-tl-item">
                <div className="cc-tl-left">
                  <div className="cc-tl-step">{item.step}</div>
                  {i < timelineSteps.length - 1 && <div className="cc-tl-connector" />}
                </div>
                <div className="cc-tl-body">
                  <h3 className="cc-tl-title">{item.title}</h3>
                  <p className="cc-tl-desc">{item.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── CTA ── */}
      <section className="cc-cta">
        <div className="cc-cta-inner">
          <div className="cc-cta-glow" />
          <span className="cc-eyebrow cc-eyebrow-light">Let's Partner</span>
          <h2 className="cc-cta-title">Invite Intlrr to Your Campus</h2>
          <p className="cc-cta-sub">
            Partner with Intlrr Campus Connect to enhance finance readiness across your student community.
          </p>
          <Link to="/contact" className="cc-cta-btn">
            Invite Intlrr to Campus →
          </Link>
        </div>
      </section>

      {/* ── STYLES ── */}
      <style jsx>{`

        /* ── Base Tokens ── */
        :root {
          --green: #2ECC9A;
          --green-dark: #1aab7d;
          --navy: #0f1f2e;
          --navy-mid: #1b3145;
          --surface: #f4f7f6;
          --surface-card: #ffffff;
          --text-primary: #0f1f2e;
          --text-secondary: #4a5e6d;
          --text-muted: #7a8c99;
          --radius-lg: 1.25rem;
          --radius-md: 0.875rem;
          --shadow-card: 0 4px 24px rgba(15,31,46,0.07);
          --shadow-hover: 0 12px 40px rgba(15,31,46,0.13);
        }

        /* ── HERO ── */
        .cc-hero {
          background: linear-gradient(135deg, #f0f6f4 0%, #e8f4ef 60%, #d8eee6 100%);
          padding: 7rem 2rem 5rem;
          overflow: hidden;
        }
        .cc-hero-inner {
          max-width: 1200px;
          margin: 0 auto;
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 4rem;
          align-items: center;
        }
        .cc-badge {
          display: inline-block;
          background: rgba(46,204,154,0.15);
          color: var(--green-dark);
          border: 1px solid rgba(46,204,154,0.3);
          padding: 0.35rem 1rem;
          border-radius: 999px;
          font-size: 0.8rem;
          font-weight: 600;
          letter-spacing: 0.06em;
          text-transform: uppercase;
          margin-bottom: 1.5rem;
        }
        .cc-hero-title {
          font-size: clamp(2.4rem, 4vw, 3.4rem);
          font-weight: 700;
          color: var(--text-primary);
          line-height: 1.15;
          margin: 0 0 1.25rem;
        }
        .cc-accent { color: var(--green); }
        .cc-hero-sub {
          font-size: 1.05rem;
          color: var(--text-secondary);
          line-height: 1.75;
          max-width: 480px;
          margin-bottom: 2.5rem;
        }
        .cc-hero-cta {
          display: inline-block;
          background: var(--green);
          color: #fff;
          font-weight: 600;
          font-size: 0.95rem;
          padding: 0.85rem 2rem;
          border-radius: 999px;
          text-decoration: none;
          transition: background 0.2s, transform 0.2s, box-shadow 0.2s;
          box-shadow: 0 4px 16px rgba(46,204,154,0.35);
        }
        .cc-hero-cta:hover {
          background: var(--green-dark);
          transform: translateY(-2px);
          box-shadow: 0 8px 24px rgba(46,204,154,0.45);
        }

        /* Hero visual / floating cards */
        .cc-hero-visual {
          position: relative;
          height: 340px;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .cc-visual-blob {
          width: 280px;
          height: 280px;
          background: radial-gradient(circle at 40% 40%, rgba(46,204,154,0.22), rgba(46,204,154,0.04) 70%);
          border-radius: 50%;
          position: absolute;
        }
        .cc-visual-card {
          position: absolute;
          background: #fff;
          border-radius: var(--radius-md);
          padding: 1rem 1.4rem;
          display: flex;
          flex-direction: column;
          box-shadow: var(--shadow-card);
          border: 1px solid rgba(46,204,154,0.15);
          animation: floatCard 4s ease-in-out infinite;
        }
        .cc-vc1 { top: 10%; left: 5%; animation-delay: 0s; }
        .cc-vc2 { top: 40%; right: 5%; animation-delay: 1.3s; }
        .cc-vc3 { bottom: 8%; left: 20%; animation-delay: 2.5s; }
        .cc-vc-num {
          font-size: 1.6rem;
          font-weight: 700;
          color: var(--green);
          line-height: 1;
        }
        .cc-vc-lbl {
          font-size: 0.75rem;
          color: var(--text-muted);
          margin-top: 0.25rem;
        }
        @keyframes floatCard {
          0%, 100% { transform: translateY(0); }
          50% { transform: translateY(-8px); }
        }

        /* ── STATS STRIP ── */
        .cc-stats-strip {
          background: var(--navy);
          padding: 2.5rem 2rem;
        }
        .cc-stats-inner {
          max-width: 900px;
          margin: 0 auto;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 0;
        }
        .cc-stat-cell {
          flex: 1;
          display: flex;
          flex-direction: column;
          align-items: center;
          position: relative;
        }
        .cc-stat-num {
          font-size: 2.2rem;
          font-weight: 700;
          color: var(--green);
          line-height: 1;
        }
        .cc-stat-lbl {
          font-size: 0.85rem;
          color: rgba(255,255,255,0.6);
          margin-top: 0.4rem;
          text-align: center;
        }
        .cc-stat-divider {
          position: absolute;
          right: 0;
          top: 10%;
          height: 80%;
          width: 1px;
          background: rgba(255,255,255,0.12);
        }

        /* ── SECTION SHARED ── */
        .cc-section-inner {
          max-width: 1200px;
          margin: 0 auto;
          padding: 0 2rem;
        }
        .cc-section-header {
          text-align: center;
          margin-bottom: 3.5rem;
        }
        .cc-eyebrow {
          display: inline-block;
          font-size: 0.75rem;
          font-weight: 700;
          letter-spacing: 0.1em;
          text-transform: uppercase;
          color: var(--green-dark);
          margin-bottom: 0.75rem;
        }
        .cc-eyebrow-light { color: rgba(46,204,154,0.9); }
        .cc-section-title {
          font-size: clamp(1.6rem, 2.5vw, 2.2rem);
          font-weight: 700;
          color: var(--text-primary);
          margin: 0 0 0.75rem;
        }
        .cc-section-sub {
          font-size: 1rem;
          color: var(--text-secondary);
          max-width: 520px;
          margin: 0 auto;
          line-height: 1.7;
        }

        /* ── WHAT WE DELIVER ── */
        .cc-deliver {
          padding: 6rem 2rem;
          background: #fff;
        }
        .cc-cards-grid {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 1.75rem;
        }
        .cc-card {
          background: var(--surface);
          border-radius: var(--radius-lg);
          padding: 2.25rem 2rem;
          border: 1px solid rgba(15,31,46,0.07);
          transition: transform 0.25s, box-shadow 0.25s, border-color 0.25s;
        }
        .cc-card:hover {
          transform: translateY(-6px);
          box-shadow: var(--shadow-hover);
          border-color: rgba(46,204,154,0.3);
        }
        .cc-card-icon { font-size: 2.4rem; line-height: 1; }
        .cc-card-title {
          font-size: 1.1rem;
          font-weight: 700;
          color: var(--text-primary);
          margin: 1.1rem 0 0.6rem;
        }
        .cc-card-desc {
          font-size: 0.875rem;
          color: var(--text-secondary);
          line-height: 1.7;
          margin-bottom: 1.4rem;
        }
        .cc-card-features {
          list-style: none;
          padding: 0;
          margin: 0;
          display: flex;
          flex-direction: column;
          gap: 0.55rem;
        }
        .cc-card-features li {
          display: flex;
          align-items: flex-start;
          gap: 0.6rem;
          font-size: 0.85rem;
          color: var(--text-primary);
        }
        .cc-check {
          color: var(--green);
          font-weight: 700;
          margin-top: 1px;
          flex-shrink: 0;
        }

        /* ── LOGOS MARQUEE ── */
        .cc-logos-section {
          padding: 5.5rem 0;
          background: var(--surface);
          overflow: hidden;
        }
        .cc-logos-section .cc-section-inner { margin-bottom: 3rem; }
        .cc-logos-section .cc-section-title { color: var(--text-primary); }
        .cc-marquee-wrap {
          position: relative;
          overflow: hidden;
        }
        .cc-marquee-fade {
          position: absolute;
          top: 0;
          bottom: 0;
          width: 120px;
          z-index: 2;
          pointer-events: none;
        }
        .cc-fade-left { left: 0; background: linear-gradient(to right, var(--surface), transparent); }
        .cc-fade-right { right: 0; background: linear-gradient(to left, var(--surface), transparent); }
        .cc-marquee { overflow: hidden; }
        .cc-marquee-track {
          display: flex;
          animation: marqueeScroll 32s linear infinite;
          width: max-content;
        }
        .cc-logo-item {
          padding: 0 3rem;
          display: flex;
          align-items: center;
        }
        .cc-logo-item img {
          height: 56px;
          filter: grayscale(100%);
          opacity: 0.65;
          transition: opacity 0.3s, filter 0.3s;
        }
        .cc-logo-item img:hover {
          opacity: 1;
          filter: grayscale(0%);
        }
        @keyframes marqueeScroll {
          from { transform: translateX(0); }
          to { transform: translateX(-50%); }
        }

        /* ── HOW IT WORKS ── */
        .cc-how {
          padding: 6rem 2rem;
          background: #fff;
        }
        .cc-timeline {
          max-width: 780px;
          margin: 0 auto;
        }
        .cc-tl-item {
          display: flex;
          gap: 2rem;
          position: relative;
        }
        .cc-tl-left {
          display: flex;
          flex-direction: column;
          align-items: center;
          flex-shrink: 0;
        }
        .cc-tl-step {
          width: 56px;
          height: 56px;
          border-radius: 50%;
          background: var(--green);
          color: #fff;
          font-weight: 700;
          font-size: 0.9rem;
          display: flex;
          align-items: center;
          justify-content: center;
          box-shadow: 0 4px 16px rgba(46,204,154,0.35);
          flex-shrink: 0;
        }
        .cc-tl-connector {
          width: 2px;
          flex: 1;
          background: linear-gradient(to bottom, rgba(46,204,154,0.4), rgba(46,204,154,0.1));
          margin: 0.5rem 0;
          min-height: 2rem;
        }
        .cc-tl-body {
          background: var(--surface);
          border-radius: var(--radius-md);
          padding: 1.6rem 2rem;
          margin-bottom: 1rem;
          flex: 1;
          border: 1px solid rgba(15,31,46,0.06);
          transition: box-shadow 0.2s, border-color 0.2s;
        }
        .cc-tl-body:hover {
          box-shadow: var(--shadow-card);
          border-color: rgba(46,204,154,0.25);
        }
        .cc-tl-title {
          font-size: 1.05rem;
          font-weight: 700;
          color: var(--text-primary);
          margin: 0 0 0.4rem;
        }
        .cc-tl-desc {
          font-size: 0.875rem;
          color: var(--text-secondary);
          line-height: 1.7;
          margin: 0;
        }

        /* ── CTA ── */
        .cc-cta {
          background: var(--navy);
          padding: 7rem 2rem;
          position: relative;
          overflow: hidden;
        }
        .cc-cta-glow {
          position: absolute;
          width: 600px;
          height: 600px;
          background: radial-gradient(circle, rgba(46,204,154,0.12) 0%, transparent 70%);
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          pointer-events: none;
        }
        .cc-cta-inner {
          max-width: 680px;
          margin: 0 auto;
          text-align: center;
          position: relative;
          z-index: 1;
        }
        .cc-cta-title {
          font-size: clamp(1.8rem, 3vw, 2.6rem);
          font-weight: 700;
          color: #fff;
          margin: 0.5rem 0 1rem;
        }
        .cc-cta-sub {
          font-size: 1rem;
          color: rgba(255,255,255,0.65);
          line-height: 1.75;
          margin-bottom: 2.5rem;
        }
        .cc-cta-btn {
          display: inline-block;
          background: var(--green);
          color: #fff;
          font-weight: 600;
          font-size: 1rem;
          padding: 1rem 2.4rem;
          border-radius: 999px;
          text-decoration: none;
          transition: background 0.2s, transform 0.2s, box-shadow 0.2s;
          box-shadow: 0 4px 20px rgba(46,204,154,0.4);
        }
        .cc-cta-btn:hover {
          background: var(--green-dark);
          transform: translateY(-2px);
          box-shadow: 0 8px 32px rgba(46,204,154,0.5);
        }

        /* ── Responsive ── */
        @media (max-width: 900px) {
          .cc-hero-inner {
            grid-template-columns: 1fr;
            gap: 3rem;
            text-align: center;
          }
          .cc-hero-content { order: 1; }
          .cc-hero-visual { order: 0; height: 220px; }
          .cc-hero-sub { margin: 0 auto 2.5rem; }
          .cc-cards-grid { grid-template-columns: 1fr; }
          .cc-stats-inner { flex-direction: column; gap: 2rem; }
          .cc-stat-divider { display: none; }
        }

        @media (max-width: 640px) {
          .cc-tl-item { gap: 1.2rem; }
          .cc-tl-step { width: 44px; height: 44px; font-size: 0.8rem; }
        }
      `}</style>

    </div>
  );
};

export default CampusConnect;